import { NgModule} from '@angular/core';
import { NG_MODULE_DECLARATION} from "./app-dependencies";

@NgModule(NG_MODULE_DECLARATION)
export class AppModule { }
